module.exports = __webpack_public_path__ + "static/media/assessments.9a4ab418.svg";